<template>
  <label @click="click" class="PaB-checkbox">
    <icon-base icon-name="checked-square" v-if="isChecked" width="16" height="16">
      <icon-checked-square />
    </icon-base>

    <icon-base icon-name="square" v-if="!isChecked" width="16" height="16">
      <icon-square />
    </icon-base>

    <span class="PaB-checkbox-label">
      <slot></slot>
    </span>
  </label>
</template>

<style lang="scss" scoped>
.PaB-checkbox {
  display: block;
  cursor: pointer;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  line-height: 1.1;
  padding-top: 0.2em;
  padding-bottom: 0.2em;

  svg {
    flex: 0 0 auto;
    margin-right: 0.25em;
  }
}
</style>

<script>
import IconBase from '@/components/IconBase'
import IconCheckedSquare from '@/components/icons/IconCheckedSquare'
import IconSquare from '@/components/icons/IconSquare'

export default {
  name: 'Checkbox',
  props: ['checked', 'value'],
  model: {
    prop: 'checked',
    event: 'input'
  },
  components: {
    IconBase,
    IconCheckedSquare,
    IconSquare
  },
  computed: {
    isChecked () {
      if (Array.isArray(this.checked)) {
        return this.checked.includes(this.value)
      }
      return this.checked
    }
  },
  methods: {
    click () {
      let checked = !this.checked

      if (Array.isArray(this.checked)) {
        checked = [].concat(this.checked)
        if (checked.includes(this.value)) {
          checked.splice(checked.indexOf(this.value), 1)
        } else {
          checked.push(this.value)
        }
      }

      this.$emit('input', checked)
    }
  }
}
</script>
